





















import AdminAds from '@/components/Admin/AdminAds.vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import Vue from 'vue';
import RouterTabs from '@/components/RouterTabs.vue';
import {Tab} from '@/types/Tabs';

@Component({
  name: 'Admin',
  components: {
    RouterTabs,
    AdminForm: AdminAds,
  },
})
export default class Admin extends Vue {
  @Prop({type: String, required: true}) readonly auth!: string;

  private tabs: Array<Tab> = [
    {
      pathName: 'AdminAds',
      title: 'Lista zgłoszeń',
    },
    {
      pathName: 'AdminComments',
      title: 'Lista komentarzy',
    },
  ];

  created() {
    this.$cookies.set('x-auth', this.auth, {expires: '24h'});
  }
}
